export const AlternativeAmountConfiguration: {
  [key: string]: {
    min: number;
    max: number;
    currency: string;
  };
} = {
  XCoinsCryptoLTC: {
    min: 20,
    max: 25000,
    currency: 'EUR',
  },
  XCoinsHelp2PayIDR: {
    min: 300000,
    max: 400000000,
    currency: 'IDR',
  },
  XCoinsHelp2PayKRW: {
    min: 30000,
    max: 40000000,
    currency: 'KRW',
  },
  XCoinsHelp2PayMYR: {
    min: 100,
    max: 100000,
    currency: 'MYR',
  },
  XCoinsHelp2PayTHB: {
    min: 800,
    max: 800000,
    currency: 'THB',
  },
  XCoinsHelp2PayVND: {
    min: 550000,
    max: 620000000,
    currency: 'VND',
  },
  XCoinsNeteller: {
    min: 20,
    max: 25000,
    currency: 'EUR',
  },
  XCoinsPayWithClick: {
    min: 20,
    max: 25000,
    currency: 'EUR',
  },
  XCoinsPIX: {
    min: 20,
    max: 25000,
    currency: 'USD',
  },
  XCoinsSkrill: {
    min: 20,
    max: 25000,
    currency: 'EUR',
  },
  XCoinsVolt: {
    min: 20,
    max: 25000,
    currency: 'EUR',
  },
  NowPaymentsGardarian: {
    min: 10,
    max: 12000,
    currency: 'EUR',
  },
  SheepyBuyCryptoBCH: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  SheepyBuyCryptoBNB: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  SheepyBuyCryptoBTC: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  SheepyBuyCryptoDOGE: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  SheepyBuyCryptoETH: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  SheepyBuyCryptoLTC: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  SheepyBuyCryptoTRX: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  SheepyBuyCryptoUSDT: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  SheepyBuyCryptoXRP: {
    min: 20,
    max: 200,
    currency: 'EUR',
  },
  PlatCoreP2Plari: {
    min: 10,
    max: 4000,
    currency: 'GEL',
  },
  PlatCoreP2Plira: {
    min: 50,
    max: 150000,
    currency: 'TRY',
  },
  PlatCoreP2Prub: {
    min: 300,
    max: 300000,
    currency: 'RUB',
  },
  HeroPaymentsWertCrypto: {
    min: 10,
    max: 8000,
    currency: 'EUR',
  },
  HeroPaymentsWertCryptoBTC: {
    min: 30,
    max: 8000,
    currency: 'EUR',
  },
};
